<template>
    <div class="content">
        <div class="header">
            <div>{{ $t("Notification.Notification") }}</div>
            <div class="close">
                <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
            </div>
        </div>
        <div class="tab">
            <div class="tab-item" :class="{ 'act': tabAct == 1 }" @click.stop="tabAct = 1">{{ $t('Notification.news') }}
            </div>
            <div class="tab-item" :class="{ 'act': tabAct == 2 }" @click.stop="tabAct = 2">{{
                $t('Notification.Notification') }}</div>
        </div>
        <div class="tab-content">
            <div v-if="tabAct == 1" class="main_content">
                <div class="list" v-if="noticeList.length">
                    <div class="list_items" v-for="(item, index) in noticeList" :key="index" @click="toDetail(item)">
                        <div class="top_box">
                            <div class="time">{{ item.createTime }}</div>
                            <div class="title">
                                {{ item.title }}
                            </div>
                        </div>
                        <div class="info-wrap">{{ item.introduction }}</div>
                    </div>
                    <div class="load_txt">
                        <span>{{ $t("Notification.nomore") }}</span>
                    </div>
                </div>
                <div v-else class="nodata">
                    <img src="@/assets/common/empty.png" />
                    <div class="empty">{{ $t("lang.empty") }}</div>
                </div>
            </div>
            <div v-if="tabAct == 2" class="main_content"></div>
        </div>
        <div class="main_content" v-if="tabAct == 2">
            <div class="list" v-if="NoticationList.length">
                <div class="list_items" v-for="(item, index) in NoticationList" :key="index"
                    @click="toMsgDetail(item.id)">
                    <div class="top_box">
                        <div class="time">{{ item.createTime }}</div>
                        <div class="title">
                            {{ item.messgeType }}
                        </div>
                    </div>
                    <div class="info-wrap">{{ item.conut }}</div>
                </div>
                <div class="load_txt">
                    <span>{{ $t("Notification.nomore") }}</span>
                </div>
            </div>
            <div v-else class="nodata">
                <img src="@/assets/common/empty.png" />
                <div class="empty">{{ $t("lang.empty") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getNotication, getArticleList } from '@/api/notication'
export default {
    name: 'NotificationContent',
    data() {
        return {
            tabAct: 1,
            noticeList: [],
            NoticationList: []
        }
    },
    created() { },
    methods: {
        close() {
            this.$emit('close')
        },
        open() {
            this.getNotication()
            this.getArticleList()
            this.$nextTick(() => { })
        },
        getArticleList() {
            getArticleList({ id: 2 }).then(res => {
                if (res?.code) return
                const D = res?.result
                this.noticeList = D
            })
        },
        getNotication() {
            getNotication().then(res => {
                if (res?.code) return
                const D = res?.result
                this.NoticationList = D.value1
            })
        },
        toDetail(D) {
            const obj = {
                id: D.id,
                eventName: D.title,
                createTime: D.createTime,
                eventContent: D.content
            }
            const params = encodeURIComponent(JSON.stringify(obj))
            const timestamp = new Date().getTime()
            this.onNavTo({ url: 'PromotionCustom', type: 'post', params: { timestamp, params } })
        },
        toMsgDetail(id) {
            const params = encodeURIComponent(JSON.stringify({ id }))
            const timestamp = new Date().getTime()
            this.onNavTo({ url: 'MsgDetail', type: 'post', params: { timestamp, params } })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.content {
    width: 100%;
    height: 100%;
    background: #000;
    box-sizing: border-box;
    overflow: auto;

    .header {
        display: flex;
        height: 1rem;
        padding-left: .3rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: .1rem;
        background: $bg-popup-navbar-color;

        &>div:first-child {
            font-size: .28rem;
            font-weight: bold;
            color: #fff;
        }

        .close {
            color: #8c7463;
            font-size: .36rem;
            font-weight: bold;
            height: 1rem;
            width: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }
    }

    .tab {
        transform: translateZ(0);
        box-sizing: content-box;
        display: flex;
        color: #d8c1b0;
        background: #191b21;
        font-size: 14px;
        width: 100%;
        height: 50px;

        .tab-item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            cursor: pointer;

            &.act {
                color: #fff;
                font-weight: 600;
                background: linear-gradient(180deg, rgba(255, 115, 0, 0) 31.77%, rgba(255, 115, 0, .2) 80.21%, rgba(255, 115, 0, .3) 94.78%, #ff7300 94.79%);
            }
        }
    }

    .main_content {
        padding: 0 .2rem;
        flex: 1;
        overflow: hidden auto;

        .list_items {
            border-radius: .14rem;
            box-sizing: border-box;
            position: relative;
            margin-top: .2rem;
            border: .02rem solid #2a2f39;
            background: #383e4b;
            padding: .2rem;
            cursor: pointer;

            .top_box {
                // display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .title {
                cursor: pointer;
                font-size: .24rem;
                color: #ffffff;
                max-width: 100%;
                text-align: left;
                word-wrap: break-word;
            }

            .time {
                font-size: .19rem;
                color: #B1BAD3;
                text-align: left;
            }

            .info-wrap {
                margin-top: .2rem;
                font-size: .22rem;
                color: #8c7463;
                line-height: 1.3;
                text-align: left;
                cursor: pointer;
            }
        }

        .load_txt {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            font-family: Poppins;
            font-style: normal;
            // font-weight: 600;
            font-size: .24rem;
            margin-top: .6rem;
            color: #8c7463;
        }

        .nodata {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            height: 3rem;

            img {
                width: 100%;
            }

            .empty {
                margin-top: .4rem;
                text-align: center;
                color: #8c7463;
                font-size: .24rem;
            }
        }
    }
}

.content {
    background: linear-gradient(180deg, rgba(80, 5, 8, .98) 0%, rgba(44, 3, 5, .99) 100%);

    .header .close {
        color: #d7b37d;
    }

    .tab {
        color: #d7b37d;
        background: rgba(89, 6, 10, .76);

        .tab-item.act {
            color: #fff1d7;
            background: linear-gradient(180deg, rgba(255, 240, 184, 0) 31.77%, rgba(217, 166, 60, .16) 80.21%, rgba(217, 166, 60, .26) 94.78%, #d9a63c 94.79%);
        }
    }

    .main_content .list_items {
        border-color: rgba(205, 137, 61, .28);
        background: linear-gradient(180deg, rgba(129, 11, 16, .96) 0%, rgba(94, 6, 10, .98) 100%);
    }

    .main_content .list_items .time,
    .main_content .list_items .info-wrap,
    .main_content .load_txt,
    .main_content .nodata .empty {
        color: #d7b37d;
    }
}

.content {
    background: linear-gradient(180deg, rgba(88, 7, 11, .98) 0%, rgba(57, 4, 7, .99) 100%);
    border: 1px solid rgba(212, 152, 76, .2);
    box-shadow: 0 .12rem .28rem rgba(35, 3, 4, .34);

    .header {
        background: linear-gradient(180deg, rgba(169, 20, 25, .98) 0%, rgba(130, 9, 15, .98) 58%, rgba(100, 6, 11, .99) 100%);
        border-bottom: 1px solid rgba(205, 137, 61, .18);

        >div:first-child {
            color: #fff4dc;
        }

        .close {
            color: #f0d8a0;
        }
    }

    .tab {
        color: #d8bc8a;
        background: rgba(88, 6, 10, .84);
        border-bottom: 1px solid rgba(205, 137, 61, .18);

        .tab-item {
            transition: background .2s ease, color .2s ease;

            &.act {
                color: #fff2d8;
                background: linear-gradient(180deg, rgba(255, 240, 184, 0) 24%, rgba(217, 166, 60, .14) 72%, rgba(217, 166, 60, .24) 92%, #d9a63c 92%);
            }
        }
    }

    .main_content {
        background: transparent;

        .list_items {
            border-color: rgba(205, 137, 61, .24);
            background: linear-gradient(180deg, rgba(129, 11, 16, .98) 0%, rgba(90, 6, 10, .98) 100%);
            box-shadow: inset 0 1px 0 rgba(255, 234, 196, .04);

            .title {
                color: #fff1dc;
            }

            .time,
            .info-wrap {
                color: #d8bc8a;
            }
        }

        .load_txt,
        .nodata .empty {
            color: #d8bc8a;
        }
    }
}
</style>
